import { LESSON_CONTENT_TYPES, MODAL_TYPES, LESSON_TYPES } from '../constants';

export const modalLessonType = (
  lessonType,
  lessonContent,
  contentVersionId,
  setContentVersionId,
  isJointUser,
) => {
  if (lessonType === LESSON_TYPES.TOPIC) {
    return MODAL_TYPES.TOPIC_DETAILS;
  }
  if (lessonType === LESSON_TYPES.CONTENT && isJointUser) {
    return MODAL_TYPES.CONTENT_LESSON;
  }
  if (lessonContent === LESSON_CONTENT_TYPES.SEISMIC) {
    if (contentVersionId) {
      setContentVersionId(null);
    }
    return MODAL_TYPES.CONTENT_LESSON;
  }
  return MODAL_TYPES.ADD_TEXT_SPACE_BELOW;
};
